import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Module } from 'data/terra/Module';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { ModuleSelectorState } from '../reducer';

export const selectModule = (
  moduleId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState
) => {
  const selectedModule = getState().moduleSelector.modules.find(
    m => m.id === moduleId
  );

  dispatch({
    type: SELECT_MODULE,
    selectedModule,
  });
};

export const SELECT_MODULE = 'SELECT_MODULE';

export interface SelectModuleAction {
  type: typeof SELECT_MODULE;
  selectedModule: Module;
}

export const selectModuleDelegate: DelegateMapEntry<
  SelectModuleAction,
  ModuleSelectorState
> = {
  [SELECT_MODULE]: (
    state: ModuleSelectorState,
    action: SelectModuleAction
  ): ModuleSelectorState => {
    return {
      ...state,
      selectedModule: action.selectedModule,
    };
  },
};
